<template>
  <slot />
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      recoverElem: null,
      loginElem: null,
      recoverTrigger: null,
      loginTrigger: null,
    }
  },
  mounted () {
    this.setElems()
    this.checkUrl()
    this.eventListeners()
  },
  methods: {
    recover () {
      this.recoverElem.classList.remove('hidden')
      this.loginElem.classList.add('hidden')
    },
    login () {
      this.recoverElem.classList.add('hidden')
      this.loginElem.classList.remove('hidden')
    },
    setElems () {
      this.recoverElem = document.querySelector('.account-login--recover')
      this.loginElem = document.querySelector('.account-login--login')
      this.recoverTrigger = document.querySelector('[href="#recover"]')
      this.loginTrigger = document.querySelector('[href="#login"]')
    },
    checkUrl () {
      if (location.href.indexOf("#recover") != -1) {
        this.recover()
      } else {
        this.login()
      }
    },
    eventListeners () {
      this.recoverTrigger.addEventListener('click', () => { this.recover() })
      this.loginTrigger.addEventListener('click', () => { this.login() })
    }
  },
}
</script>
